import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ChartIcon } from 'src/ui/assets/icons/other/ChartIcon';
import { withConfig } from 'src/withConfig';

interface ChartPropsType {
    isExpanded: boolean;
}

export const Chart = withConfig(theme => styled(ChartIcon, { label: 'Chart' })<ChartPropsType>`
    bottom: 0;
    cursor: pointer;
    color: ${({ isExpanded }) => isExpanded ? theme.star.raceCard.stats.bgColorQuaternary : theme.star.raceCard.stats.bgColorTertiary};
    height: 24px;
    margin: auto 0;
    padding: 4px;
    position: absolute;
    right: 0;
    top: 0;
    width: 24px;
`);

interface UnnamedFavouritePropsType {
    isAntePost: boolean;
}

export const UnnamedFavouriteLabel = styled('div', { label: 'UnnamedFavouriteLabel' })<UnnamedFavouritePropsType>`
    align-items: center;
    border-right: none;
    display: flex;
    flex: 1 1 auto;
    justify-content: flex-start;
    padding-left: ${({ isAntePost }): string => isAntePost ? '8px' : '16px'};
`;

interface PriceHistoryCellPropsType {
    isRaceInProgress?: boolean;
    variant: DefaultComponentVariantType | null;
}

export const PriceHistoryCell = withConfig(theme => styled('span', { label: 'PriceHistoryCell' })<PriceHistoryCellPropsType>`
    align-items: center;
    border-color: ${theme.star.raceSummary.borderColor};
    border-style: solid;
    border-width: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? '0' : `0 1px`};
    display: flex;
    flex: 0 0 76px;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
    padding: 2px 4px;
    text-align: center;
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 108px;
    }
`);
